import { msgcli } from "../API/MessageClient";
import { playerCore } from "./PlayerCore";

// TODO
export const listenTogether = new (class ListenTogether {
  init() {}

  createSession() {
    // Generate random id
    // this.joinSession(id)
  }

  joinSession() {
    // msgcli.listenEvent('lt/${id}')
  }

  leaveSession() {}

  openUI() {}
})();
